import axios from "../../axios";

const topUpStock = async (product_id, stock) => {
  console.log(product_id, stock, "topUpStock");
  try {
    const { data } = await axios.put(`/products/topup/${product_id}`, { stock });
  } catch (e) {
    console.log(e);
    throw e;
  }
}

export { topUpStock };